module.exports = __webpack_public_path__ + "assets/7ffc8ba6a70cc5b26bb99bb7b1ddaabc.png";